import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css"
const Footer = () => {
    return (
        <div className="">
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="footer-col">
                            <h4 className="h4-cls">company</h4>
                            <ul>
                                <li><a href="#">about us</a></li>
                                <li><a href="#">our services</a></li>
                                <li><a href="#">privacy policy</a></li>
                                <li><a href="#">Maternity</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4 className="h4-cls">get help</h4>
                            <ul>
                                <li><a href="#">FAQ</a></li>
                                <li><a href="#">ECG/END</a></li>
                                <li><a href="#">ICU</a></li>
                                <li><a href="#">Rehabilitation</a></li>

                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4 className="h4-cls">Live Care</h4>
                            <ul>
                                <li><a href="#">Prime Care</a></li>
                                <li><a href="#">Laboratary</a></li>
                                <li><a href="#">Imaging</a></li>
                                <li><a href="#">Clinics</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4 className="h4-cls">follow us</h4>
                            <div className="social-links">
                                <a href="#"><i className="fab fa-facebook-f"></i></a>
                                <a href="#"><i className="fab fa-twitter"></i></a>
                                <a href="#"><i className="fab fa-instagram"></i></a>
                                <a href="#"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default Footer;